import React, { Component } from 'react';
import { connect } from 'react-redux';
import PubNub from 'pubnub';
import {
  Col,
  Row,
  Select,
  Spin,
  Button,
  notification,
  Typography,
  Menu,
} from 'antd';
import { withRouter } from 'react-router-dom';
import config from '../../config';
import { getAllOperators } from '../services/api/pending-onboarding';
import { setOperators, setCommentOpened } from '../actions';
import SuggestionsDialog from '../components/suggestions/SuggestionsDialog';
import { fetchCenters, fetchDoctors } from '../services';
import { debounce } from '../utils';

const { Option } = Select;
const { Text } = Typography;

class NewPendingOnboardingHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appBarTitle: 'Doctor Registration Form',
      doctorId: null,
      docData: null,
      open: false,
      ncIdForEdit: null,
      openRegisterNetworkCenter: false,
      openChat: false,
      selectedRequestId: null,
      pendingOnboardings: [],
      requestId: null,
      showSuggestions: false,
      fetchingDoctors: false,
      fetchedDoctors: [],
      fetchingCenters: false,
      fetchedCenters: [],
      userDetails: {},
    };
    if (!props.authToken) {
      props.history.push('/');
    }
    this.debouncedFetchHealthCenters = debounce(this.onSearchCenter, 600);
    this.debouncedFetchDoctors = debounce(this.onSearchDoctor, 600);
    this.pubnubClient = new PubNub({
      subscribeKey: config.pubnubSubscribeKey,
      publishKey: config.pubnubPublishKey,
    });
  }

  componentDidMount() {
    const { dispatch } = this.props;
    this.fetchAllOperators();
    this.pubnubClient.subscribe({
      channels: [config.notificationChannel],
      withPresence: false,
    });
    this.pubnubClient.addListener({
      message: (msg) => {
        console.log(msg, 'Incoming message');
        // check for incoming message and update the status
        if (msg.message) {
          const messagePayload = msg.message;
          // update the state
          notification.info({
            key: msg.timetoken,
            message: `${messagePayload.name}: ${messagePayload.text}`,
            onClick: () => {
              if (messagePayload.requestId) {
                dispatch(
                  setCommentOpened({
                    requestId: messagePayload.requestId,
                  })
                );
              }
            },
            duration: 4,
          });
        }
      },
    });
  }

  componentDidUpdate(prevProps, prevState) {
    this.pubnubClient.unsubscribeAll();
  }

  fetchAllOperators = () => {
    const dispatch = this.props.dispatch;
    getAllOperators()
      .then((resp) => {
        if (resp.message === 'success') {
          let currentOperator;
          if (this.props.user.userId) {
            currentOperator = resp.operators.find(
              (o) => o.operatorId === this.props.user.userId
            );
          }
          this.setState({
            userDetails: resp.userDetails,
          });
          dispatch(
            setOperators({
              operators: resp.operators,
              currentOperator,
              sponsors: resp.sponsors,
              verticals: resp.verticals,
              cities: resp.cities,
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getRequestIdFromNotificationPanel = (requestId) => {
    this.setState({
      selectedRequestId: requestId,
      openChat: true,
    });
  };

  openSuggestions = () => {
    console.log('Open Suggestions');
    this.setState({
      showSuggestions: true,
    });
  };

  closeSuggestions = () => {
    console.log('Close Suggestions');
    this.setState({
      showSuggestions: false,
    });
  };

  onSearchDoctor = (value) => {
    this.setState({ fetchingDoctors: true });
    if (value.trim() === '') {
      this.setState({
        fetchedDoctors: [],
        fetchingDoctors: false,
      });
      return;
    }
    fetchDoctors(value)
      .then((res) => {
        this.setState({
          fetchedDoctors: res.result.map((ele) => ({
            key: ele.doctorId,
            label: `${ele.doctorName}-${ele.verticalName}`,
            ...ele,
          })),
        });
      })
      .finally(() => {
        this.setState({
          fetchingDoctors: false,
        });
      });
  };

  onSearchCenter = (value) => {
    this.setState({ fetchingCenters: true });
    if (value.trim() === '') {
      this.setState({
        fetchedCenters: [],
        fetchingCenters: false,
      });
      return;
    }
    fetchCenters(value)
      .then((res) => {
        this.setState({
          fetchedCenters: res.result.map((ele) => ({
            key: ele.centerId,
            label: ele.title,
            locality: ele.locality,
          })),
        });
      })
      .finally(() => {
        this.setState({
          fetchingCenters: false,
        });
      });
  };

  render() {
    const {
      fetchingDoctors,
      fetchedDoctors,
      fetchingCenters,
      fetchedCenters,
      userDetails,
    } = this.state;
    const { history } = this.props;
    return (
      <div>
        <Menu
          theme="dark"
          mode="horizontal"
          selectable={false}
          style={{ lineHeight: '64px', float: 'left' }}
        >
          <Menu.Item
            key="1"
            onClick={() => history.push('/home')}
            style={{ backgroundColor: '#53c1b2', color: '#001629' }}
          >
            Pluton
          </Menu.Item>
          <Menu.Item onClick={() => history.push('/doctor-profile/new')}>
            New Doctor
          </Menu.Item>

          <Menu.Item
            onClick={() => history.push('/center-profile/new')}
            key="4"
          >
            New Center
          </Menu.Item>
          <Menu.Item onClick={() => history.push('/on-the-fly')} key="5">
            On the Fly
          </Menu.Item>
          <Menu.Item style={{ width: '200px' }}>
            <Select
              showSearch
              style={{ width: '100%' }}
              dropdownMatchSelectWidth={false}
              notFoundContent={fetchingDoctors ? <Spin size="small" /> : null}
              defaultActiveFirstOption={false}
              showArrow={false}
              filterOption={false}
              placeholder="Doctors"
              onSearch={this.debouncedFetchDoctors}
              onChange={(e) => {
                // Navigate to doctor profile page
                console.log(e);
                history.push(`/doctor-profile/${e}`);
              }}
            >
              {fetchedDoctors.map((d) => (
                <Option key={d.key}>
                  <Row>{d.label}</Row>
                  <Row>
                    {d.centers.map((center) => (
                      <Col>
                        <Text
                          code
                        >{`${center.hospitalName}, ${center.locality}`}</Text>
                        <Text code>
                          Is Active - {center.isActive ? 'Yes' : 'No'}
                        </Text>
                        <Text code>Status - {center.status}</Text>
                      </Col>
                    ))}
                  </Row>
                </Option>
              ))}
            </Select>
          </Menu.Item>
          <Menu.Item style={{ width: '200px' }}>
            <Select
              showSearch
              style={{ width: '100%' }}
              dropdownMatchSelectWidth={false}
              notFoundContent={fetchingCenters ? <Spin size="small" /> : null}
              defaultActiveFirstOption={false}
              showArrow={false}
              filterOption={false}
              placeholder="Centers"
              onSearch={this.debouncedFetchHealthCenters}
              onChange={(e) => {
                // Navigate to doctor profile page
                console.log(e);
                history.push(`/center-profile/${e}`);
              }}
            >
              {fetchedCenters.map((d) => (
                <Option key={d.key}>
                  <Col>
                    {d.label}({d.locality}){' '}
                    <Text code>Is Active - {d.isActive ? 'Yes' : 'No'}</Text>
                  </Col>
                </Option>
              ))}
            </Select>
          </Menu.Item>
          <Menu.Item onClick={this.openSuggestions}>Suggestions</Menu.Item>
          <Menu.Item onClick={() => history.push('/featured-centers-city')}>
            Featured Centers
          </Menu.Item>
          <Menu.SubMenu key="sub1" title="Actions">
            <Menu.Item onClick={() => history.push('/center-data-requests')}>
              Center Data Requests
            </Menu.Item>
            <Menu.Item onClick={() => history.push('/vaccination-sponsors')}>
              Vaccination Sponsors
            </Menu.Item>
            {userDetails && userDetails.userType === 'admin' && (
              <Menu.Item onClick={() => history.push('/approval-requests')}>
                Approval Requests
              </Menu.Item>
            )}
            {userDetails && userDetails.userType === 'admin' && (
              <Menu.Item onClick={() => history.push('/add-user')}>
                Add user
              </Menu.Item>
            )}
          </Menu.SubMenu>

          {/* {userDetails && userDetails.userType === 'admin' && (
            <Menu.Item onClick={() => history.push('/approval-requests')}>
              Approval Requests
            </Menu.Item>
          )}
          {userDetails && userDetails.userType === 'admin' && (
            <Menu.Item onClick={() => history.push('/add-user')}>
              Add user
            </Menu.Item>
          )} */}
        </Menu>
        <SuggestionsDialog
          isOpen={this.state.showSuggestions}
          closeSuggestions={this.closeSuggestions}
          verticals={this.props.verticals}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    comments: state.comments,
    user: state.user,
    verticals: state.info.verticals,
    authToken: state.user.authToken,
  };
}

export default withRouter(connect(mapStateToProps)(NewPendingOnboardingHome));
